var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTime = function SvgIconTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M19 10.506c0 .687-.077 1.357-.223 2m-.713-6A9 9 0 1 0 9 19.45m9.064-12.945v-3m0 3H15.5M12 19.283a9 9 0 0 0 2-.713m2-1.356a9 9 0 0 0 1.485-1.708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10 6.506v5h5"
  })));
};
export { SvgIconTime as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDEwLjUwNTlDMTkgMTEuMTkzMiAxOC45MjI5IDExLjg2MjYgMTguNzc3IDEyLjUwNTlNMTguMDY0NSA2LjUwNTg2QzE2LjU5MTggMy41NDI0MiAxMy41MzM3IDEuNTA1ODYgMTAgMS41MDU4NkM1LjAyOTQ0IDEuNTA1ODYgMSA1LjUzNTMgMSAxMC41MDU5QzEgMTUuMTM4NCA0LjUwMDA1IDE4Ljk1MzUgOSAxOS40NTA5TTE4LjA2NDUgNi41MDU4NlYzLjUwNTg2TTE4LjA2NDUgNi41MDU4NkgxNS41TTEyIDE5LjI4MjhDMTIuNzAxMyAxOS4xMjM3IDEzLjM3MTUgMTguODgyNyAxNCAxOC41NzAzTTE2IDE3LjIxNDJDMTYuNTYzMiAxNi43MTAxIDE3LjA2MjYgMTYuMTM2MSAxNy40ODQ1IDE1LjUwNTkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMCA2LjUwNTg2VjExLjUwNTlIMTUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";